module.exports = __webpack_public_path__ + "1f15d378a3ef0feb7f80915514d47de4.png";